import React, { useState } from 'react';
import { BadgeIndianRupee } from 'lucide-react';
import { Panel, AddButton, RowButton, StatusToggle, PageHeading } from '../ui';
import { LICENCE_POLICIES } from '../../../lib/familyData';
export function LicenceManager() {
  const [status, setStatus] = useState<Record<string, boolean>>(() => Object.fromEntries(LICENCE_POLICIES.map(l => [l.id, true])));
  return <div data-id="element-486" data-mp="1a56cwigjhvg3">
      <PageHeading title="Licence Policy Manager" subtitle="Subscription grants sold via the Family App. subscriptionId maps to the JS bridge purchase payload." data-id="element-487" data-mp="1a4wx1np7l4o4" />
      <Panel title="Licence Policies" icon={<BadgeIndianRupee className="h-4 w-4 text-[#1e2a5a]" data-id="element-489" data-mp="1148jsv7n38ca" />} action={<AddButton label="New licence" data-id="element-490" data-mp="w5x80exsanrf" />} data-id="element-488" data-mp="113qgxfqh1vve">
        <table className="w-full text-sm" data-id="element-491" data-mp="w78dcj6vo3kn">
          <thead data-id="element-492" data-mp="2vgycxaq6odim">
            <tr className="border-b border-slate-200 text-left text-slate-600" data-id="element-493" data-mp="2vhhjjvadvfhc">
              <th className="px-5 py-3 font-semibold" data-id="element-494" data-mp="2qjy6gypf98qz">Name</th>
              <th className="px-5 py-3 font-semibold" data-id="element-495" data-mp="2v0zhmow4g80f">subscriptionId</th>
              <th className="px-5 py-3 font-semibold" data-id="element-496" data-mp="2v32gzzj5zdht">Price</th>
              <th className="px-5 py-3 font-semibold" data-id="element-497" data-mp="2z3mamt4j3yz7">Period</th>
              <th className="px-5 py-3 font-semibold" data-id="element-498" data-mp="2l31slz6fu76r">Status</th>
              <th className="px-5 py-3 text-right font-semibold" data-id="element-499" data-mp="2l4mrg0zsccaf">Actions</th>
            </tr>
          </thead>
          <tbody data-id="element-500" data-mp="2q3zcqhb0dbaw">
            {LICENCE_POLICIES.map(l => <tr key={l.id} className="border-b border-slate-100 last:border-0" data-id="element-501" data-mp="3dss8acnpxh4z">
                <td className="px-5 py-3.5 font-medium text-slate-800" data-id="element-502" data-mp="3iqtv98o9m0lq">
                  {l.name}
                  {l.recommended && <span className="ml-2 rounded-full bg-[#f4b8c0] px-2 py-0.5 text-[10px] font-bold text-slate-800" data-id="element-503" data-mp="341e6fy8ao58o">
                      Featured
                    </span>}
                </td>
                <td className="px-5 py-3.5 font-mono text-xs text-slate-500" data-id="element-504" data-mp="j4bl4czq8tl">
                  {l.id}
                </td>
                <td className="px-5 py-3.5 text-slate-700" data-id="element-505" data-mp="f86186n5m2o4">₹{l.price}</td>
                <td className="px-5 py-3.5 text-slate-600" data-id="element-506" data-mp="f5a2ig3hf9ym">{l.period}</td>
                <td className="px-5 py-3.5" data-id="element-507" data-mp="a9cm69s7y3lu">
                  <StatusToggle on={status[l.id]} onToggle={() => setStatus(s => ({
                ...s,
                [l.id]: !s[l.id]
              }))} data-id="element-508" data-mp="596tcqa7qb26" />
                </td>
                <td className="px-5 py-3.5" data-id="element-509" data-mp="3sexzzqm1amb2">
                  <div className="flex justify-end gap-2" data-id="element-510" data-mp="3nnfz12k0glq3">
                    <RowButton variant="read" data-id="element-511" data-mp="3nlv61hdchauc">Read</RowButton>
                    <RowButton variant="edit" data-id="element-512" data-mp="3intmkvc0b9ic">Edit</RowButton>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </Panel>

      <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-id="element-513" data-mp="39nezbqfhfkc7">
        <strong data-id="element-514" data-mp="34o21kan2osuu">Webhook note:</strong> grants are only created after the signed
        Razorpay webhook is confirmed server-side, and the handler is idempotent
        by payment ID — duplicate webhooks never create duplicate grants.
      </div>
    </div>;
}